import { BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { TreeItemContent } from "@mui/x-tree-view-pro";

export const RateBuilderTreeItemContent = styled(TreeItemContent, { name: "RateBuilderTreeItemContent" })<BoxProps>(
  ({ theme }) => ({
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    backgroundColor: theme.palette.custom.blueGrey[100],
    borderRadius: `${theme.shape.borderRadius}px !important`,
    alignItems: "stretch",
    minWidth: "fit-content",
    cursor: "auto",
    "&:hover": {
      backgroundColor: theme.palette.custom.blueGrey[100],
    },
    "&.dragged": {
      outline: "1px solid var(--lines-color)",
    },
    "&.RateBuilderTreeItemContent-focused": {
      animationName: "focused-in",
      animationDuration: "0.5s",
      animationDirection: "alternate",
      animationIterationCount: 1,
      outlineOffset: "-4px",
    },
    "@keyframes focused-in": {
      "0%": { transform: "scale(1)" },
      "50%": { transform: "scale(1.03)" },
      "100%": { transform: "scale(1)" },
    },
  })
);
